import React from 'react';
import NavElementsStyles from './NavElements.module.css';
import HamburgerButton from './HamburgerButton/HamburgerButton.js';


export default function NavElements({children}){
    return <React.Fragment>
        <HamburgerButton>
            {
                children
            }
        </HamburgerButton>
        <div className={`collapse navbar-collapse ${NavElementsStyles.NavElements}`} id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        {children}
                    </ul>
                </div>
    </React.Fragment>
}